<template>
    <div class="activity-split-button">
        <ActivityButton :object="object" :label="label" :data-bot="dataBot" v-on="$listeners" />
        <CompassMenu placement="bottom-end" size="small">
            <button class="activity-split-button__icon-button">
                <CompassIcon icon="caret-down-fill" size="small" />
            </button>
            <template slot="dropdown">
                <CompassMenuItem
                    v-for="(item, index) in menuItems"
                    :key="index"
                    :label="item.label"
                    :data-bot="item.dataBot"
                    @click="item.action"
                />
            </template>
        </CompassMenu>
    </div>
</template>
<script>
import ActivityButton from 'vcomponents/common/activity/ActivityButton/ActivityButton.vue';

export default {
    components: {
        ActivityButton,
    },
    props: {
        object: {
            type: String,
            default: () => {},
        },
        label: {
            type: String,
            default: '',
        },
        dataBot: {
            type: String,
            default: '',
        },
        menuItems: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
<style lang="scss" scoped>
.activity-split-button {
    align-items: center;
    display: inline-flex;

    &::v-deep {
        .activity-button {
            border-radius: var(--spacing-0) 0 0 var(--spacing-0);
            border-right: 0;
            order: 1;
        }

        .compass-menu {
            order: 3;
        }
    }

    &:before {
        content: '';
        background: var(--colors-common-border-default);
        display: block;
        height: 100%;
        order: 2;
        transition: all 100ms cubic-bezier(0, 0, 0.3, 1);
        width: 1px;
    }

    &:hover {
        &:before {
            background: var(--colors-common-border-default-hover);
        }
    }

    &__icon-button {
        align-items: center;
        background: var(--colors-common-background-default);
        border: 1px solid var(--colors-common-border-default);
        border-left: 0;
        border-radius: 0 var(--spacing-0) var(--spacing-0) 0;
        cursor: pointer;
        display: flex;
        height: var(--spacing-5);
        justify-content: center;
        padding: 0;
        transition: all 100ms cubic-bezier(0, 0, 0.3, 1);
        width: var(--spacing-5);

        &:hover {
            border-color: var(--colors-common-border-default-hover);
        }
    }
}
</style>
